//@flow
export const CONFIRMATION_MESSAGE = `
  All traces of this kiosk's account 
  will be gone and their access will be revoked. You'll 
  need to create a new account if they need to be 
  reinstated.`



// WEBPACK FOOTER //
// ./src/Kiosks/constants.js